import { withProcedureWraper } from "../../../../..";
import ProcedureLayout from "../../../../../../../components/layouts/procedure-layout";
import { CreateApplicationForSuspendContractForm } from "../../../components/create-application-for-suspend-contract";

export const SuspendContractCreate = withProcedureWraper(() => {
  return (
    <ProcedureLayout title="Đơn xin tạm hoãn hợp đồng lao động">
      <CreateApplicationForSuspendContractForm />
    </ProcedureLayout>
  );
});
